<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar
                    id="response-code-toolbar"
                    flat
                >
                    <v-row>
                        <v-col
                            cols="6"
                            class="d-flex align-center"
                        >
                            <v-btn
                                icon
                                class="btn-back"
                                to="/reports"
                            >
                                <v-icon class="material-icons-outlined">
                                    chevron_left
                                </v-icon>
                            </v-btn>
                            <v-toolbar-title> Report History </v-toolbar-title>
                        </v-col>
                        <v-col
                            cols="6"
                            class="text-right d-flex flex-row-reverse align-center"
                        >
                            <v-btn
                                color="primary"
                                outlined
                                class="text-capitalize text-right"
                                @click="refresh"
                            >
                                <v-icon left>
                                    mdi-refresh
                                </v-icon>
                                Refresh
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row
            class="mt-0"
            :no-gutters="this.$vuetify.breakpoint.xs"
        >
            <v-col>
                <v-data-table
                    id="Reports-table"
                    :headers="headers"
                    :items="reportList"
                    class="elevation-1 mx-2"
                    :loading="loading"
                    fixed-header
                    hide-default-footer
                    :disable-pagination="true"
                    item-key="layer_id"
                >
                    <template v-slot:item.queued_date="{item}">
                        {{ `${moment(item.queued_date).format('MM/DD/YYYY, hh:mm A')}` }}
                    </template>
                    <template v-slot:item.reportURL="{item}">
                        <a
                            v-if="item.success"
                            :href="item.reportURL"
                            target="_blank"
                        >{{ item.task_output_ref }}</a>
                        <i v-else>Report execution failed</i>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import webtmsBackend from '@/services/webtmsBackend';
import moment from 'moment';

import constants from '../../constants';
const NEWTIN_HOST = constants.NEWTIN_DOMAIN || '';

export default {
    name: 'ReportList',
    data: () => ({
        loading: false,
        moment: moment,
        headers: [
            {
                text: 'Generated Date',
                align: 'left',
                sortable: false,
                value: 'queued_date',
            },
            {
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'task_name',
            },
            {
                text: 'Format',
                align: 'left',
                sortable: false,
                value: 'fileExtenstion',
            },
            {
                text: 'Report',
                align: 'left',
                sortable: false,
                value: 'reportURL',
            }
        ],
    }),
    computed: {
        getReports() {
            return this.$store.getters.reportList;
        },
        getUser() {
            return this.$store.getters.user;
        },
        reportList() {
            return this.getReports.map(item => {
                let newItem = { ...item };
                newItem.reportURL = NEWTIN_HOST + '/NewtinWeb/userdata/' + this.getUser.account + '$' + this.getUser.uid.slice(1, -1) + '/' + item.task_output_ref;
                if(typeof item.task_output_ref === 'string' && item.task_output_ref.length) {
                    newItem.fileExtenstion = item.task_output_ref.split('.');
                    newItem.fileExtenstion = newItem.fileExtenstion.length > 1 ? newItem.fileExtenstion[1] : '';
                    newItem.fileExtenstion = newItem.fileExtenstion.toUpperCase();
                }
                return newItem;
            });
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        async refresh() {
            this.loading = true;
            let response = await webtmsBackend.getReportHistory();
            this.$store.commit('SET_REPORTS', response.reportHistory);
            this.loading = false;
        }
    },
};
</script>

<style>
#Reports-table .v-data-table-header tr th {
    background-color: var(--ll-surface-subtle);
}
#Reports-table i {
    color: var(--ll-text-brand);
}
</style>
